import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('GE');
